import { getTheme, mergeStyleSets, FontWeights } from '@fluentui/react';
import { helpbuttonStyle, convertToLocalStyle } from '@bingads-webui-campaign-react/common-styles';

const theme = getTheme();
export const contentStyles = mergeStyleSets({
  container: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'stretch',
    borderRadius: '8px',
    maxHeight: '54vh',
    maxWidth: '54vw',
  },
  header: [
    theme.fonts.xLargePlus,
    {
      flex: '1 1 auto',
      color: theme.palette.neutralPrimary,
      display: 'flex',
      alignItems: 'center',
      fontWeight: FontWeights.semibold,
      padding: '12px 12px 14px 24px',
    },
  ],
  heading: {
    color: theme.palette.neutralPrimary,
    fontWeight: FontWeights.semibold,
    fontSize: 'inherit',
    margin: '0',
  },
  body: {
    flex: '4 4 auto',
    padding: '0 24px 24px 24px',
    overflowY: 'hidden',
    '&& .ms-DetailsHeader': {
      overflowX: 'auto',
      overflowY: 'hidden',
      '-ms-overflow-style': 'none',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      '& .ms-DetailsHeader-cellName': {
        ...convertToLocalStyle(helpbuttonStyle({})),
      },
    },
    '&& .ms-DetailsList-contentWrapper': {
      overflowX: 'auto',
      '-ms-overflow-style': 'none',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    '&& .scroll-bar-child:first-child': {
      position: 'inherit',
    },
    selectors: {
      p: { margin: '14px 0' },
      'p:first-child': { marginTop: 0 },
      'p:last-child': { marginBottom: 0 },
    },
    '& .conditional-formatting-cell': {
      padding: '12px 8px 12px 12px', margin: '-11px -8px -11px -12px',
    },
  },
  noDataplaceHolder: {
    color: '#605e5c',
    padding: '3px 0 20px 30px',
    fontSize: '26px',
    lineHeight: '36px',
  },
});

export const iconButtonStyles = {
  root: {
    color: theme.palette.neutralPrimary,
    marginLeft: 'auto',
    marginTop: '4px',
    marginRight: '2px',
  },
  rootHovered: {
    color: theme.palette.neutralDark,
  },
};
